module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAFVBMVEXBAAD////ggIDLKCjkj4/sr6/GFBQVTUroAAAAU0lEQVR42u3XsQ2AQBADQQMP/ZdMQHLRC8EFSMw0sJklZ2mwZUpD45JCQ0ND42uNUaQY1ctG7tDQ0NDoaNh2DQ2NHzb2wj/XeNBYGxwBAAAAACZO7xYLuQVd1AwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/to.png
// module id = 646
// module chunks = 0